// extracted by mini-css-extract-plugin
export var root = "_zp-0";
export var scroll = "_zp-1";
export var thumb = "_zp-3";
export var track = "_zp-2";